import { api } from "@/lib/api";
import {
  CreatePaymentAdjustment,
  createPaymentAdjustmentToDto,
  PaymentAdjustment,
  PaymentAdjustmentDtoSchema,
  paymentAdjustmentFromDto,
} from "@/models/payment-adjustment";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getPaymentAdjustmentsQueryOptions } from "./get.hooks";

export function useCreatePaymentAdjustment(opts?: {
  onSuccess?: (paymentAdjustment: PaymentAdjustment) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (paymentAdjustment: CreatePaymentAdjustment) => {
      const dto = createPaymentAdjustmentToDto(paymentAdjustment);
      const result = await api.post(
        "/api/payment-adjustments",
        dto,
        PaymentAdjustmentDtoSchema,
      );
      return paymentAdjustmentFromDto(result);
    },
    onSuccess: (paymentAdjustment) => {
      queryClient.setQueryData(
        getPaymentAdjustmentsQueryOptions.queryKey,
        (old) => [...(old || []), paymentAdjustment],
      );
      toast({
        title: "toast.paymentAdjustmentCreated",
        variant: "success",
      });
    },
    onError: () => {
      toast({
        title: "toast.createPaymentAdjustmenttError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
